import React from "react";

import styles from "./CopyField.module.css";
import {useAppDispatch} from "../../../app/hooks";
import {showCopiedSuccessfullyToastNotification} from "../toastNotification/toastNotificationSlice";

interface CopyFieldProps {
    value: string | undefined
}

export const CopyField: React.FC<CopyFieldProps> = ({value}) => {

    const dispatch = useAppDispatch();

    const handleCopyClick = () => {
        if (value) {
            navigator.clipboard.writeText(value);
            dispatch(showCopiedSuccessfullyToastNotification());
        }
    }

    return <div className={styles.wrapper}>
        <span className={styles.value}>{value ?? "-"}</span>
        {value && <img
            className={styles.copyImage}
            onClick={handleCopyClick}
            src={"/copyIcon.svg"}
            alt={"copy"}
        />}
    </div>
}
